import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@store/baseQueries";
import { uploadBaseUrl } from "@store/urlPaths";
import {
  downloadFile,
  fetchFinalFile,
  fetchRawAndFinalFileUrls,
  fetchRawFile,
  regenerate,
  saveAndGenerate,
} from "./queries";

const fileApi = createApi({
  reducerPath: "file",
  baseQuery: baseQuery(uploadBaseUrl),
  endpoints: (builder) => ({
    // save and genearate
    saveAndGenerate: builder.mutation({
      query: saveAndGenerate,
    }),

    // fetch raw  files
    fetchRawFile: builder.mutation({
      query: fetchRawFile,
    }),

    // fetch final files
    fetchFinalFile: builder.mutation({
      query: fetchFinalFile,
    }),

    // download file
    downloadFile: builder.mutation({
      query: downloadFile,
    }),

    fetchRawAndFinalFileUrls: builder.query({
      query: fetchRawAndFinalFileUrls,
    }),

    // regenerate
    regenerate: builder.query({
      query: regenerate,
    }),
  }),
});

export const {
  useSaveAndGenerateMutation,
  useFetchRawFileMutation,
  useFetchFinalFileMutation,
  useDownloadFileMutation,
  useFetchRawAndFinalFileUrlsQuery,
  useLazyRegenerateQuery,
  reducer: fileReducer,
  reducerPath: fileReducerPath,
  middleware: fileMiddleware,
} = fileApi;
